export const normalizeApiBaseUrl = (url?: string) => {
  if (typeof url !== 'string' || url.length === 0) {
    return undefined;
  }

  // TEMP(PVF-446): compatibility shim for local/worktree VITE_API_URL values ending in /v1.
  // REMOVE once environment config consistently provides the bare backend host and no caller
  // relies on passing a `/v1`-suffixed API base URL into the generated SDK clients.
  // grep: TEMP(PVF-446)
  return url.replace(/\/v1\/?$/, '');
};
